/* jslint esversion: 6 */
/**
 * Debug Supporting Scripts
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	// $window : $(window),
};

function init() {

	/** resize textarea.debug */
	$('textarea.debug').on('change keyup keydown paste cut', function() {
		const offset = -12;
		const height = 102;

		if ( this.scrollHeight < height ) {
			$(this).height(0).height((this.scrollHeight + offset));
		}
	}).change();
}

export {init as default};
